import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ClientITProfile, Project } from 'src/app/_models';

@Component({
    standalone: false,
  selector: 'integration-apps-oscal-implementation',
  templateUrl: './integration-apps-oscal-implementation.component.html',
  styleUrls: ['./integration-apps-oscal-implementation.component.css'],
})
export class IntegrationAppsOscalImplementationComponent
  implements OnInit, OnDestroy
{
  private projectSubscription: Subscription;
  @Input() projects: (Project & {
    itProfiles: ClientITProfile[];
  })[];
  @Input() settings: any;
  @Input() settingsForm: FormGroup;

  constructor(private fb: FormBuilder) {}

  itProfiles: ClientITProfile[] = [];

  fedRampLevels = ['Not a FedRAMP Project', 'High', 'Moderate', 'Low'];

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.settingsForm.addControl(
      'project',
      this.fb.control('', Validators.required)
    );
    this.settingsForm.addControl(
      'itProfile',
      this.fb.control('', Validators.required)
    );
    this.settingsForm.addControl(
      'fedRampLevel',
      this.fb.control('', Validators.required)
    );
    this.settingsForm.addControl(
      'isRlink',
      this.fb.control('', Validators.required)
    );
    this.settingsForm.addControl(
      'dummyRlink',
      this.fb.control('', Validators.required)
    );

    this.settingsForm.patchValue(this.settings);

    this.projectSubscription = this.settingsForm
      .get('project')
      .valueChanges.subscribe((project) => {
        this.itProfiles =
          this.projects.find((p) => p.name === project)?.itProfiles ?? [];
      });
  }

  ngOnDestroy(): void {
    this.projectSubscription?.unsubscribe();
  }
}
